var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdviserNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 57C92 76.33 76.33 92 57 92C37.67 92 22 76.33 22 57",
    stroke: "#081E56",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102C77.8781 102 95.4353 87.7818 100.517 68.5M12 57C12 32.1472 32.1472 12 57 12C74.6686 12 89.9589 22.1828 97.3224 37",
    stroke: "#FDE966",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2C87.3757 2 112 26.6243 112 57C112 59.7172 111.803 62.3884 111.422 65M14.1636 22.5C6.55503 31.9351 2 43.9356 2 57C2 85.3482 23.4468 108.687 51 111.676",
    stroke: "#F4F4F9",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9863 75.2041H44.0391V69.5352L53.7158 59.7529C55.667 57.749 57.2314 56.0791 58.4092 54.7432C59.6045 53.3896 60.4658 52.1592 60.9932 51.0518C61.5381 49.9443 61.8105 48.7578 61.8105 47.4922C61.8105 45.9629 61.3799 44.8203 60.5186 44.0645C59.6748 43.291 58.541 42.9043 57.1172 42.9043C55.623 42.9043 54.1729 43.2471 52.7666 43.9326C51.3604 44.6182 49.8926 45.5938 48.3633 46.8594L43.9336 41.6123C45.041 40.6631 46.21 39.7666 47.4404 38.9229C48.6885 38.0791 50.1299 37.4023 51.7646 36.8926C53.417 36.3652 55.3945 36.1016 57.6973 36.1016C60.2285 36.1016 62.3994 36.5586 64.21 37.4727C66.0381 38.3867 67.4443 39.6348 68.4287 41.2168C69.4131 42.7812 69.9053 44.5566 69.9053 46.543C69.9053 48.6699 69.4834 50.6123 68.6396 52.3701C67.7959 54.1279 66.5654 55.8682 64.9482 57.5908C63.3486 59.3135 61.415 61.2207 59.1475 63.3125L54.1904 67.9795V68.3486H70.9863V75.2041Z",
    fill: "#081E56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.3281,
    cy: 56.7041,
    r: 35,
    stroke: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserNumber2);
export default __webpack_public_path__ + "static/media/Adviser-Number2.173d0fd4fe710c48103bd5d5684ab9bb.svg";
export { ForwardRef as ReactComponent };